import HomeView from '../views/HomeView'
import SpeedOutlined from '@material-ui/icons/SpeedOutlined'
import MyDataView from '../views/General/MyDataView'
import AccountBoxOutlinedIcon from '@material-ui/icons/AccountBoxOutlined'
import ProductView from '../views/Products/ProductsView'
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined'
import ListAltOutlinedIcon from '@material-ui/icons/ListAltOutlined'
import OrdersView from '../views/Orders/OrdersView'
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined'
import HistoryView from '../views/Orders/HistoryView'
import AssignmentTurnedInOutlined from '@material-ui/icons/AssignmentTurnedInOutlined'
import IncidencesView from '../views/incidences/IncidencesView'
import AssignmentLateOutlinedIcon from '@material-ui/icons/AssignmentLateOutlined'
import NonConformityView from '../views/NonConformity/NonConformityView'
import ReportsView from '../views/Reports/ReportsView'
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined'
import ModifiedProductsView from '../views/Products/Modifications/ModifiedProductsView'
import OrderDetailsView from '../views/Orders/OrderDetailsView'
import IrpIncidenceView from '../views/IrpIncidences/IrpIncidenceView'
import GeneralCatalog from '../views/General/GeneralCatalog'

const routes = [
  {
    path: '/',
    exact: true,
    title: 'Inicio',
    isDrawerItem: true,
    isShortcut: false,
    icon: <SpeedOutlined color="secondary" />,
    view: () => <HomeView />
  },

  {
    title: 'DATOS GENERALES',
    children: [
      {
        path: '/my-data',
        exact: true,
        title: 'Mis Datos',
        isDrawerItem: true,
        isShortcut: true,
        shortcutTitle: 'Mis Datos',
        icon: <AccountBoxOutlinedIcon color="secondary" />,
        view: () => <MyDataView />
      }
    ]
  },
  {
    title: 'MIS PRODUCTOS',
    children: [
      {
        path: '/products',
        exact: true,
        title: 'Artículos',
        isDrawerItem: true,
        isShortcut: true,
        shortcutTitle: 'Modificar mis artículos',
        icon: <LocalMallOutlinedIcon color="secondary" />,
        view: () => <ProductView />
      },
      {
        path: '/modified-products',
        exact: true,
        title: 'Modificaciones',
        isDrawerItem: true,
        isShortcut: false,
        icon: <LocalMallOutlinedIcon color="secondary" />,
        view: () => <ModifiedProductsView />
      },
      {
        path: '/general-catalog',
        exact: true,
        title: 'Catálogo General',
        isDrawerItem: true,
        isShortcut: true,
        shortcutTitle: 'Catálogo General',
        icon: <ListAltOutlinedIcon color="secondary" />,
        view: () => <GeneralCatalog />
      }
    ]
  },
  {
    title: 'MIS PEDIDOS',
    children: [
      {
        path: '/orders',
        exact: true,
        title: 'Pendientes',
        isDrawerItem: true,
        isShortcut: true,
        shortcutTitle: 'Confirmar mis pedidos',
        icon: <AssignmentOutlinedIcon color="secondary" />,
        view: () => <OrdersView />
      },
      {
        path: '/orders/:orderNumber/:level',
        exact: true,
        title: 'Detalle del pedido',
        isDrawerItem: false,
        isShortcut: false,
        view: () => <OrderDetailsView />
      },
      {
        path: '/orders-history',
        exact: true,
        title: 'Entregados',
        isDrawerItem: true,
        isShortcut: false,
        icon: <AssignmentTurnedInOutlined color="secondary" />,
        view: () => <HistoryView />
      }
    ]
  },
  {
    title: 'MIS INCIDENCIAS',
    children: [
      {
        path: '/incidences',
        exact: true,
        title: 'Pedidos',
        isDrawerItem: true,
        isShortcut: false,
        isIncidence: true,
        icon: <AssignmentLateOutlinedIcon color="secondary" />,
        view: () => <IncidencesView />
      },
      {
        path: '/non-conformity-incidences',
        exact: true,
        title: 'No Conformidad',
        isDrawerItem: true,
        isShortcut: false,
        isIncidence: true,
        icon: <AssignmentLateOutlinedIcon color="secondary" />,
        view: () => <NonConformityView />
      },
      {
        path: '/irp-incidences',
        exact: true,
        title: 'IRP',
        isDrawerItem: true,
        isShortcut: false,
        isIncidence: true,
        icon: <AssignmentLateOutlinedIcon color="secondary" />,
        view: () => <IrpIncidenceView />
      }
    ]
  },
  {
    title: 'MIS REPORTES',
    children: [
      {
        path: '/reports',
        exact: true,
        title: 'Reportes',
        isDrawerItem: true,
        isShortcut: true,
        shortcutTitle: 'Ver mis reportes',
        icon: <AssessmentOutlinedIcon color="secondary" />,
        view: () => <ReportsView />
      }
    ]
  }
]

export const getRoutes = (routesToHide = []) => {
  const shouldShowRoute = (child) => !routesToHide.includes(child.path)

  return routes
    .filter((route) => !route.children || route.children.some(shouldShowRoute))
    .map((route) =>
      route.children
        ? {
            ...route,
            children: route.children.filter(shouldShowRoute)
          }
        : route
    )
}

export default routes
